export default {
  description: '{{name}} i {{city}}. Officielt menukort. Spar penge og bestil online her.',
};
